export default __webpack_public_path__ + "static/media/3f293e669b5c69494bd4befbfd5783dd.svg";